export function TrustFooter() {

  return (
    <footer className="w-full text-center py-6 border-t border-slate-900 bg-slate-950 text-[11px] font-mono tracking-tight text-slate-500 select-none relative z-50">
      <div className="space-y-1 px-4">
        <div>
          Intellectual Property Application No: 22026050461A — Certified Local-First Privacy-Preserving Tax Compliance Core Engine. Fully BIR Registered.
        </div>
        <div>
          Designed &amp; built by{' '}
          <a
            href="https://www.linkedin.com/in/nisi-ryan-cruz-69922212b/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-emerald-500 hover:text-emerald-400 hover:underline transition-all duration-200"
          >
            Nisi Ryan Cruz
          </a>
          {' '}·{' '}
          <span
            className="text-slate-500"
          >
            CruzFind Technologies, Inc.
          </span>{' '}
          All Rights Reserved.
        </div>
      </div>

    </footer>
  );
}

export default TrustFooter;
